import { getActiveTokens } from "@/shared/auth/helper/getActiveTokens.helper";

// In development mode, we can either login with a test user or an authenticated staging user.
// This method is used to check whether active tokens for an authenticated user exist (e.g. for the logout or mulesoft API requests)
export const hasAuthenticatedUser = async () => {
  const tokens = await getActiveTokens();
  return !!tokens;
};
